import React, { useEffect, useState } from 'react';
import './Tile.css';

interface TileProps {
    value: number | null;
}

const Tile: React.FC<TileProps> = ({ value }) => {
    const [isMerged, setIsMerged] = useState(false);
    const [prevValue, setPrevValue] = useState(value);

    useEffect(() => {
        if (value && value !== prevValue && prevValue !== null) {
            setIsMerged(true);
            const timer = setTimeout(() => setIsMerged(false), 200);
            return () => clearTimeout(timer);
        }
        setPrevValue(value);
    }, [value, prevValue]);

    if (!value) return <div className="tile empty" />;

    const isNegative = value < 0;
    const tileClass = `tile ${isNegative ? 'tile-negative' : `tile-${value}`} ${isMerged ? 'merged' : ''}`;

    return (
        <div className={tileClass}>
            <div className="tile-content">{value}</div>
        </div>
    );
};

export default Tile; 